// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IChatsGetStarredChatsDesktopRequest,
  TChatsGetStarredChatsDesktopModel,
  IMappers,
  TChatsGetStarredChatsDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IChatListResponseSchema } from '../../../entities/chat/ChatListResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsGetStarredChatsDesktopModel(
  parameters: IChatsGetStarredChatsDesktopRequest,
): TChatsGetStarredChatsDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/chats/get-starred-chats-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IChatsGetStarredChatsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IChatsGetStarredChatsDesktopRequest;
}

export async function fetchChatsGetStarredChatsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsGetStarredChatsDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsGetStarredChatsDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsGetStarredChatsDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsGetStarredChatsDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatListResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsGetStarredChatsDesktopResponse>;
}
